import { Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { CountryMapper } from "features/planner/planner.mappers";

const initialState = Map({});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_COUNTRIES: {
      if (error) return state;

      return Map(
        payload.map(country => [
          country.countryId.toString(),
          CountryMapper.from(country),
        ]),
      );
    }

    default:
      return state;
  }
};
